import { motion } from "framer-motion";
import { formatDateIT } from "@/lib/formatDate";

export default function CheckinResponsesList({ responses, labelFor }) {
  return (
    <div className="bg-[#171717] border border-[#262626] rounded-lg p-5" data-testid="checkin-responses-list">
      <h4
        className="text-sm font-bold tracking-tight uppercase text-white mb-4"
        style={{ fontFamily: "Barlow Condensed, sans-serif" }}
      >
        ULTIMI CHECK-IN ({responses.length})
      </h4>
      {responses.length === 0 ? (
        <p className="text-zinc-600 text-sm text-center py-6">
          Nessun check-in ricevuto. Quando il cliente compilerà il modulo le risposte
          appariranno qui.
        </p>
      ) : (
        <div className="space-y-3">
          {responses.map((r, i) => (
            <motion.div
              key={r.id || r.week_start}
              initial={{ opacity: 0, y: 8 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ delay: i * 0.04 }}
              className="bg-[#0A0A0A] border border-[#1A1A1A] rounded-lg p-3"
              data-testid={`checkin-response-${r.week_start}`}
            >
              <div className="flex items-center justify-between mb-2">
                <span className="text-xs text-white font-semibold">
                  Settimana del {formatDateIT(r.week_start)}
                </span>
                <span className="text-[10px] text-zinc-600">
                  Inviato {r.submitted_at ? formatDateIT(r.submitted_at.slice(0, 10)) : ""}
                </span>
              </div>
              <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-2">
                {Object.entries(r.answers || {}).map(([k, v]) => (
                  <div key={k} className="text-[11px]">
                    <span className="text-zinc-500">{labelFor(k)}: </span>
                    <span className="text-white font-medium">{String(v)}</span>
                  </div>
                ))}
              </div>
            </motion.div>
          ))}
        </div>
      )}
    </div>
  );
}
